import axios from "axios";
import { PMS_URL } from "utils/constants";

const notifyOutOfStock = async ({ email, product }) => {
    return axios.post(`${PMS_URL}/api/v1/notify_out_of_stock`, {
        email,
        vehicle_detail_id: product?.vehicle_detail?.id ?? product?.vehicle_id,
        product_id: product?.master_product_id ?? null,
    });
};

export default notifyOutOfStock;
